import {
    PropertyPaneButtonType,
    PropertyPaneCustomField,
    IPropertyPaneField,
    PropertyPaneFieldType
} from '@microsoft/sp-webpart-base';
import {
    IPropertyPaneUploadFieldProps
} from './IPropertyPaneUploadFieldProps';


export class PropertyPaneUploadField implements IPropertyPaneField<IPropertyPaneUploadFieldProps>{
    public type: PropertyPaneFieldType = PropertyPaneFieldType.Custom;
    public targetProperty: string;
    public properties: IPropertyPaneUploadFieldProps;
    private elem: HTMLElement;

    constructor(targetProperty: string, properties: IPropertyPaneUploadFieldProps) {
        this.targetProperty = targetProperty;
        /*this.properties ={
            type: 'str'
        }*/
    }

    private _onRender(){

    }

    private _onDispose(){

    }
}